// eslint-disable-next-line no-unused-vars
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';

import Button from '@/src/shared/components/Button';
import Divider from '@/src/shared/components/Divider';
import CustomIcon from '@/src/shared/components/Icon';
import { bp } from '@/styles';

import DigestPanelContent from './DigestPanelContent';

const style = {
  loadmore: css`
    margin-top: 16px;
    @media ${bp.sm} {
      margin-left: 85px;
    }
  `,
};

const PanelContent = ({ type, items, total, id }) => {
  const [loading, setLoading] = useState(false);
  const [moreItems, setMoreItems] = useState([]);

  const handleClick = () => {
    setLoading(true);
    setTimeout(() => {
      setMoreItems([
        {
          icon: <CustomIcon name="calendar" />,
          title: 'Weekly Digest',
          meta: ['06/14/2018', '04:39:58 PM'],
          description:
            'A weekly newsletter highlighting legislative, regulatory and legal developments at state and federal levels. This week Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do',
        },
      ]);
      setLoading(false);
    }, 2000);
  };

  return (
    <>
      {items && (
        <>
          {[...items, ...moreItems].map((item, i) => {
            const { icon, title, meta, description } = item;
            if (type === 'digest') {
              return (
                <Fragment key={`${title}${i + 1}`}>
                  <DigestPanelContent
                    icon={icon}
                    title={title}
                    meta={meta}
                    description={description}
                  />
                  {i < [...items, ...moreItems].length - 1 && <Divider type="smallfull" />}
                </Fragment>
              );
            }
            return item;
          })}
          {total > 3 && (
            <Button
              css={style.loadmore}
              onClick={handleClick}
              icon="sync"
              loading={loading}
              type="primary"
              key={`${id}=button`}
            >
              Load More
            </Button>
          )}
        </>
      )}
    </>
  );
};

PanelContent.propTypes = {
  type: PropTypes.oneOf(['digest', 'generic']),
  // items: PropTypes.arrayOf(
  //   PropTypes.shape({
  //     icon: PropTypes.node,
  //     title: PropTypes.string,
  //     meta: PropTypes.arrayOf(PropTypes.string),
  //     description: PropTypes.string,
  //   })
  // ),
  items: PropTypes.array,
  total: PropTypes.number,
};

PanelContent.defaultProps = {
  type: 'digest',
  items: [],
  total: 0,
};

export default PanelContent;
